export interface League {
  id: string
  game: string
  name: string
  day: string
  time: string
  timezone: string
  region: string
  spotsLeft: number
  totalSpots: number
  startsIn: string
  startDate: string
  seasonNumber: number
  weeksDuration: number
  entryFee: number
  skillLevel: "All Levels" | "Beginner Friendly" | "Intermediate" | "Competitive"
  tags: string[]
  description: string
  schedule: string
  voiceRequired: boolean
  captain: {
    name: string
    since: string
  }
}

export const LEAGUES: League[] = [
  {
    id: "val-northeast-tue",
    game: "Valorant",
    name: "Northeast Tactical",
    day: "Tuesday",
    time: "9:00 PM",
    timezone: "ET",
    region: "Northeast",
    spotsLeft: 4,
    totalSpots: 24,
    startsIn: "5 days",
    startDate: "2026-05-19",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "Competitive",
    tags: ["Competitive", "Voice Required"],
    description: "Our flagship Valorant league for players who want structured competitive play. Teams of 5 compete in a round-robin format followed by playoffs.",
    schedule: "Matches every Tuesday at 9 PM ET. Each match night runs approximately 2 hours.",
    voiceRequired: true,
    captain: { name: "Mike T.", since: "Season 3" },
  },
  {
    id: "rl-midwest-thu",
    game: "Rocket League",
    name: "Midwest Aerials",
    day: "Thursday",
    time: "8:30 PM",
    timezone: "CT",
    region: "Midwest",
    spotsLeft: 8,
    totalSpots: 18,
    startsIn: "12 days",
    startDate: "2026-05-26",
    seasonNumber: 12,
    weeksDuration: 6,
    entryFee: 15,
    skillLevel: "All Levels",
    tags: ["All Skill Levels", "3v3"],
    description: "Fast-paced 3v3 Rocket League action. We balance teams by skill level so everyone has competitive, fun matches.",
    schedule: "Matches every Thursday at 8:30 PM CT. Typical night is 90 minutes.",
    voiceRequired: false,
    captain: { name: "Sarah K.", since: "Season 7" },
  },
  {
    id: "apex-pacific-sat",
    game: "Apex Legends",
    name: "Pacific Predators",
    day: "Saturday",
    time: "7:00 PM",
    timezone: "PT",
    region: "Pacific Northwest",
    spotsLeft: 2,
    totalSpots: 20,
    startsIn: "3 days",
    startDate: "2026-05-17",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "Competitive",
    tags: ["Competitive", "Trios"],
    description: "Weekend Apex for west coast players. Trios format with point-based scoring across multiple games per night.",
    schedule: "Saturdays at 7 PM PT. Expect 2-2.5 hours per session.",
    voiceRequired: true,
    captain: { name: "Chris L.", since: "Season 1" },
  },
  {
    id: "cod-southeast-fri",
    game: "Call of Duty: Warzone",
    name: "Southern Operators",
    day: "Friday",
    time: "9:00 PM",
    timezone: "ET",
    region: "Southeast",
    spotsLeft: 12,
    totalSpots: 24,
    startsIn: "8 days",
    startDate: "2026-05-22",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "Intermediate",
    tags: ["Casual Competitive", "Quads"],
    description: "Friday night Warzone for players who want competition without the sweat. Quads format, good vibes required.",
    schedule: "Fridays at 9 PM ET. Sessions run about 2 hours.",
    voiceRequired: true,
    captain: { name: "James W.", since: "Season 5" },
  },
  {
    id: "sports-night-national",
    game: "Sports Night",
    name: "National Sports Rotation",
    day: "Sunday",
    time: "8:00 PM",
    timezone: "ET",
    region: "National",
    spotsLeft: 16,
    totalSpots: 32,
    startsIn: "10 days",
    startDate: "2026-05-24",
    seasonNumber: 12,
    weeksDuration: 9,
    entryFee: 15,
    skillLevel: "All Levels",
    tags: ["Multi-Game", "FIFA/Madden/NBA2K"],
    description: "Rotating sports games each week - EA FC, Madden, and NBA 2K. Great for sports game fans who don't want to commit to just one title.",
    schedule: "Sundays at 8 PM ET. Game rotates weekly. 2 hour sessions.",
    voiceRequired: false,
    captain: { name: "David R.", since: "Season 2" },
  },
  {
    id: "fps-sunday-mountain",
    game: "FPS Sundays",
    name: "Mountain Time Shooters",
    day: "Sunday",
    time: "7:00 PM",
    timezone: "MT",
    region: "Mountain",
    spotsLeft: 6,
    totalSpots: 20,
    startsIn: "10 days",
    startDate: "2026-05-24",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "All Levels",
    tags: ["Multi-Game", "Rotating FPS"],
    description: "Weekly rotating FPS games - Valorant, CS2, Apex, Overwatch. Vote each week for next week's game.",
    schedule: "Sundays at 7 PM MT. About 2 hours per session.",
    voiceRequired: true,
    captain: { name: "Alex M.", since: "Season 4" },
  },
  {
    id: "cs2-northeast-wed",
    game: "Counter-Strike 2",
    name: "Northeast Clutch Masters",
    day: "Wednesday",
    time: "9:30 PM",
    timezone: "ET",
    region: "Northeast",
    spotsLeft: 10,
    totalSpots: 20,
    startsIn: "6 days",
    startDate: "2026-05-20",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "Intermediate",
    tags: ["5v5", "Voice Required"],
    description: "Classic 5v5 CS2 league for players who grew up on Counter-Strike. Competitive but welcoming atmosphere.",
    schedule: "Wednesdays at 9:30 PM ET. Matches run 90 minutes to 2 hours.",
    voiceRequired: true,
    captain: { name: "Tom B.", since: "Season 1" },
  },
  {
    id: "league-southeast-mon",
    game: "League of Legends",
    name: "Southeast Summoners",
    day: "Monday",
    time: "8:00 PM",
    timezone: "ET",
    region: "Southeast",
    spotsLeft: 5,
    totalSpots: 30,
    startsIn: "4 days",
    startDate: "2026-05-18",
    seasonNumber: 12,
    weeksDuration: 10,
    entryFee: 15,
    skillLevel: "All Levels",
    tags: ["5v5", "Role Selection"],
    description: "Monday night League for southeast players. We draft teams to balance skill levels. Specify your preferred roles when signing up.",
    schedule: "Mondays at 8 PM ET. Expect 2-3 hours depending on game length.",
    voiceRequired: true,
    captain: { name: "Jennifer H.", since: "Season 6" },
  },
  {
    id: "ow2-pacific-sun",
    game: "Overwatch 2",
    name: "Pacific Payload Pushers",
    day: "Sunday",
    time: "6:00 PM",
    timezone: "PT",
    region: "Pacific",
    spotsLeft: 14,
    totalSpots: 24,
    startsIn: "10 days",
    startDate: "2026-05-24",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "All Levels",
    tags: ["5v5", "Role Queue"],
    description: "Sunday evening Overwatch for the west coast. Role queue format ensures balanced team compositions.",
    schedule: "Sundays at 6 PM PT. Sessions are about 2 hours.",
    voiceRequired: true,
    captain: { name: "Ryan P.", since: "Season 8" },
  },
  {
    id: "fortnite-national-sat",
    game: "Fortnite",
    name: "National No-Build League",
    day: "Saturday",
    time: "8:00 PM",
    timezone: "ET",
    region: "National",
    spotsLeft: 20,
    totalSpots: 40,
    startsIn: "3 days",
    startDate: "2026-05-17",
    seasonNumber: 12,
    weeksDuration: 6,
    entryFee: 15,
    skillLevel: "Beginner Friendly",
    tags: ["No Build", "Duos/Trios"],
    description: "No-build Fortnite for players who prefer gunplay over construction. Beginner-friendly environment.",
    schedule: "Saturdays at 8 PM ET. About 90 minutes per session.",
    voiceRequired: false,
    captain: { name: "Marcus J.", since: "Season 9" },
  },
  {
    id: "halo-midwest-sat",
    game: "Halo Infinite",
    name: "Midwest Spartans",
    day: "Saturday",
    time: "9:00 PM",
    timezone: "CT",
    region: "Midwest",
    spotsLeft: 8,
    totalSpots: 16,
    startsIn: "3 days",
    startDate: "2026-05-17",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "All Levels",
    tags: ["4v4", "Classic Halo"],
    description: "Saturday night Halo for midwest players. 4v4 arena format with classic Halo game types.",
    schedule: "Saturdays at 9 PM CT. Sessions run about 2 hours.",
    voiceRequired: true,
    captain: { name: "Kevin S.", since: "Season 3" },
  },
  {
    id: "fifa-southwest-tue",
    game: "EA FC 25",
    name: "Southwest Pitch Masters",
    day: "Tuesday",
    time: "8:00 PM",
    timezone: "CT",
    region: "Southwest",
    spotsLeft: 6,
    totalSpots: 16,
    startsIn: "5 days",
    startDate: "2026-05-19",
    seasonNumber: 12,
    weeksDuration: 8,
    entryFee: 15,
    skillLevel: "Intermediate",
    tags: ["1v1", "Pro Clubs Option"],
    description: "EA FC league with both 1v1 and Pro Clubs divisions. Choose your preferred format when registering.",
    schedule: "Tuesdays at 8 PM CT. About 90 minutes per session.",
    voiceRequired: false,
    captain: { name: "Carlos G.", since: "Season 5" },
  },
]

export const GAMES = [
  { id: "valorant", name: "Valorant" },
  { id: "rocket-league", name: "Rocket League" },
  { id: "cod-warzone", name: "Call of Duty: Warzone" },
  { id: "apex", name: "Apex Legends" },
  { id: "fortnite", name: "Fortnite" },
  { id: "league", name: "League of Legends" },
  { id: "cs2", name: "Counter-Strike 2" },
  { id: "overwatch", name: "Overwatch 2" },
  { id: "halo", name: "Halo Infinite" },
  { id: "fifa", name: "EA FC 25" },
  { id: "madden", name: "Madden 25" },
  { id: "nba2k", name: "NBA 2K25" },
]

export const MULTI_GAME_LEAGUES = [
  { id: "sports-night", name: "Sports Night", description: "FIFA, Madden, NBA 2K rotation" },
  { id: "fps-sundays", name: "FPS Sundays", description: "Rotating shooters weekly" },
  { id: "battle-royale-bash", name: "Battle Royale Bash", description: "Warzone, Apex, Fortnite" },
  { id: "retro-nights", name: "Retro Game Nights", description: "Classic games & remasters" },
]

export const DAYS = [
  { id: "sunday", name: "Sunday" },
  { id: "monday", name: "Monday" },
  { id: "tuesday", name: "Tuesday" },
  { id: "wednesday", name: "Wednesday" },
  { id: "thursday", name: "Thursday" },
  { id: "friday", name: "Friday" },
  { id: "saturday", name: "Saturday" },
]

export const REGIONS = {
  "new-england": {
    name: "New England",
    states: {
      "ma": { name: "Massachusetts", cities: ["Boston", "Worcester", "Springfield"] },
      "ct": { name: "Connecticut", cities: ["Hartford", "New Haven", "Stamford"] },
      "ri": { name: "Rhode Island", cities: ["Providence", "Warwick"] },
      "nh": { name: "New Hampshire", cities: ["Manchester", "Nashua"] },
      "vt": { name: "Vermont", cities: ["Burlington", "Montpelier"] },
      "me": { name: "Maine", cities: ["Portland", "Bangor"] },
    }
  },
  "northeast": {
    name: "Northeast",
    states: {
      "ny": { name: "New York", cities: ["New York City", "Buffalo", "Albany", "Rochester"] },
      "nj": { name: "New Jersey", cities: ["Newark", "Jersey City", "Trenton"] },
      "pa": { name: "Pennsylvania", cities: ["Philadelphia", "Pittsburgh", "Harrisburg"] },
    }
  },
  "southeast": {
    name: "Southeast",
    states: {
      "fl": { name: "Florida", cities: ["Miami", "Orlando", "Tampa", "Jacksonville"] },
      "ga": { name: "Georgia", cities: ["Atlanta", "Savannah", "Augusta"] },
      "nc": { name: "North Carolina", cities: ["Charlotte", "Raleigh", "Durham"] },
      "sc": { name: "South Carolina", cities: ["Charleston", "Columbia"] },
      "va": { name: "Virginia", cities: ["Virginia Beach", "Richmond", "Norfolk"] },
    }
  },
  "midwest": {
    name: "Midwest",
    states: {
      "il": { name: "Illinois", cities: ["Chicago", "Springfield", "Rockford"] },
      "oh": { name: "Ohio", cities: ["Columbus", "Cleveland", "Cincinnati"] },
      "mi": { name: "Michigan", cities: ["Detroit", "Grand Rapids", "Ann Arbor"] },
      "in": { name: "Indiana", cities: ["Indianapolis", "Fort Wayne"] },
      "wi": { name: "Wisconsin", cities: ["Milwaukee", "Madison"] },
      "mn": { name: "Minnesota", cities: ["Minneapolis", "St. Paul"] },
    }
  },
  "southwest": {
    name: "Southwest",
    states: {
      "tx": { name: "Texas", cities: ["Houston", "Dallas", "Austin", "San Antonio"] },
      "az": { name: "Arizona", cities: ["Phoenix", "Tucson", "Scottsdale"] },
      "nm": { name: "New Mexico", cities: ["Albuquerque", "Santa Fe"] },
      "ok": { name: "Oklahoma", cities: ["Oklahoma City", "Tulsa"] },
    }
  },
  "mountain": {
    name: "Mountain",
    states: {
      "co": { name: "Colorado", cities: ["Denver", "Boulder", "Colorado Springs"] },
      "ut": { name: "Utah", cities: ["Salt Lake City", "Provo"] },
      "nv": { name: "Nevada", cities: ["Las Vegas", "Reno"] },
      "id": { name: "Idaho", cities: ["Boise", "Idaho Falls"] },
      "mt": { name: "Montana", cities: ["Billings", "Missoula"] },
      "wy": { name: "Wyoming", cities: ["Cheyenne", "Casper"] },
    }
  },
  "pacific": {
    name: "Pacific",
    states: {
      "ca": { name: "California", cities: ["Los Angeles", "San Francisco", "San Diego", "Sacramento"] },
      "hi": { name: "Hawaii", cities: ["Honolulu"] },
    }
  },
  "pacific-northwest": {
    name: "Pacific Northwest",
    states: {
      "wa": { name: "Washington", cities: ["Seattle", "Spokane", "Tacoma"] },
      "or": { name: "Oregon", cities: ["Portland", "Eugene", "Salem"] },
      "ak": { name: "Alaska", cities: ["Anchorage", "Fairbanks"] },
    }
  },
}

export function filterLeagues(
  leagues: League[],
  filters: {
    games?: string[]
    days?: string[]
    regions?: string[]
  }
): League[] {
  return leagues.filter(league => {
    // Game filter
    if (filters.games && filters.games.length > 0) {
      const gameMatch = filters.games.some(g => 
        league.game.toLowerCase().includes(g.toLowerCase()) ||
        league.id.includes(g)
      )
      if (!gameMatch) return false
    }

    // Day filter
    if (filters.days && filters.days.length > 0) {
      const dayMatch = filters.days.some(d => 
        league.day.toLowerCase() === d.toLowerCase()
      )
      if (!dayMatch) return false
    }

    // Region filter
    if (filters.regions && filters.regions.length > 0) {
      const regionMatch = filters.regions.some(r => {
        const regionLower = r.toLowerCase().replace(/-/g, ' ')
        const leagueRegionLower = league.region.toLowerCase()
        return leagueRegionLower.includes(regionLower) || 
               regionLower.includes(leagueRegionLower) ||
               leagueRegionLower === "national"
      })
      if (!regionMatch) return false
    }

    return true
  })
}
